import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { Container } from 'cstar-react-primitives/lib/redux-form/layout/Container';
import { Map as IMap } from 'immutable';

import { getSelfBuyEnabled } from '../brand/brandSelectors';
import { primitiveMessages } from '../primitive/primitiveMessages';

import recipientMessages from './recipientMessages';
import RecipientNameForm from './RecipientNameForm';
import { shouldDisplayFaceplate } from './recipientStepSelectors';


export const RecipientStep = ({
    intl,
    isSelfBuyEnabled,
    isSelfBuy,
    faceplate,
    showFaceplate,
    submitAction,
    getSubmitMessage
}) => {
    const containerProps = {
        heading: intl.formatMessage(recipientMessages.title),
        showRequiredMsg: true,
        requiredMsg: intl.formatMessage(primitiveMessages.requiredInstructionText)
    };
    const formProps = {
        submitAction,
        getSubmitMessage,
        cashbotName: 'recipient',
        isSelfBuyEnabled,
        isSelfBuy,
        faceplate,
        showFaceplate
    };
    return (
        <Container {...containerProps}>
            <RecipientNameForm {...formProps} />
        </Container>
    );
};

RecipientStep.defaultProps = {
    isSelfBuyEnabled: false,
    isSelfBuy: false,
    faceplate: IMap(),
    showFaceplate: false
};

RecipientStep.propTypes = {
    
    intl: intlShape.isRequired,
    
    isSelfBuy: PropTypes.bool,
    submitAction: PropTypes.func.isRequired,
    getSubmitMessage: PropTypes.func.isRequired,
    
    isSelfBuyEnabled: PropTypes.bool,
    faceplate: PropTypes.instanceOf(IMap),
    showFaceplate: PropTypes.bool
};

const mapStateToProps = (state) => {
    const faceplateProps = shouldDisplayFaceplate(state);
    return {
        isSelfBuyEnabled: getSelfBuyEnabled(state),
        ...faceplateProps
    };
};

export default connect(mapStateToProps)(injectIntl(RecipientStep));
